import type { Milliseconds } from '@lemonade-hq/ts-helpers';
import { BASE_FRAME_TRANSITION_DURATION } from '@lemonade-hq/uniclient-chat';

const DEBUG_MULTIPLIER = 1;

export const FRAME_TRANSITION_DURATION: Milliseconds = BASE_FRAME_TRANSITION_DURATION * DEBUG_MULTIPLIER;
export const OUTPUT_TRANSITION_DURATION: Milliseconds = BASE_FRAME_TRANSITION_DURATION * DEBUG_MULTIPLIER;
export const OUTPUT_TRANSITION_DURATION_TIMEOUT: Milliseconds = 100 * DEBUG_MULTIPLIER;
export const HISTORY_ITEM_OUT_DURATION: Milliseconds = 100 * DEBUG_MULTIPLIER;

export const FRAME_TYPE_PAGE_TRANSITION_DURATION: Milliseconds = 2300;

export const MIN_COMPONENT_ANIMATION_DELAY: Milliseconds = 30;
